module.exports = __webpack_public_path__ + "b1ff597e496337b5f20c420bca83a7e4.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/rockers.jpg
 ** module id = 446
 ** module chunks = 0
 **/